import ItodoImage from "../../../elements/itodo-img";
import { NavLink } from "react-router-dom";
import { blogPosts, neuronMedia } from "../../../../globals/neuron-content";

function getPostTags(title) {
  const lower = title.toLowerCase();
  if (lower.includes("heat")) {
    return ["HEAT Training", "Crisis Readiness", "Field Safety"];
  }
  if (lower.includes("surveillance")) {
    return ["Surveillance", "Reporting", "Escalation"];
  }
  if (lower.includes("liaison")) {
    return ["Stakeholder Liaison", "Community Relations", "Operational Stability"];
  }
  return ["Executive Protection", "Travel Security", "Risk Management"];
}

function SectionInsightSingle({ currentPost, currentIndex }) {
  const post = currentPost ?? blogPosts[0];
  const total = blogPosts.length;
  const resolvedIndex = Number.isInteger(currentIndex)
    ? currentIndex
    : blogPosts.findIndex((item) => item.slug === post.slug);
  const safeIndex = resolvedIndex >= 0 ? resolvedIndex : 0;
  const prev = blogPosts[(safeIndex - 1 + total) % total];
  const next = blogPosts[(safeIndex + 1) % total];
  const tags = getPostTags(post.title);
  const detailPath = `/insights/${post.slug}`;

  return (
    <>
      <div className="blog-single-space">
        <div className="sx-post-media sx-img-effect img-reflection m-b30">
          <NavLink to={detailPath}><ItodoImage src={post.image} alt={post.title} /></NavLink>
        </div>
        <div className="single-blog-post blog-detail m-b30">
          <div className="sx-post-meta">
            <ul>
              <li className="post-date"><NavLink to={detailPath}><i className="fa fa-calendar" />{post.date}</NavLink></li>
              <li className="post-author"><NavLink to={detailPath}><i className="fa fa-comments" />{post.comments} Comments</NavLink></li>
            </ul>
          </div>
          <div className="sx-post-title">
            <h2 className="post-title">{post.title}</h2>
          </div>
          <div className="sx-post-text">
            <p>{post.summary}</p>
            <p>This insight focuses on practical field execution, with clear operating steps that teams can adopt quickly across planning, deployment and escalation.</p>
            <h2 className="sx-post-detail-subtitle">Operational guidance for this insight topic</h2>
            <p>Neuron teams align briefings, supervision and communication cadence around the exact exposure profile of each assignment so decisions can be made quickly without losing control.</p>
            <p>Whether assignments involve principal movement, static asset coverage or multi-party coordination, the same discipline applies: clarity in roles, clear triggers and fast reporting loops.</p>
            <div className="row sx-about-icon-bx1-column p-tb30">
              <div className="col-lg-6 col-md-6">
                <div className="sx-icon-bx-2">
                  <div className="sx-media">
                    <i className="flaticon-security" />
                  </div>
                  <div className="sx-icon-bx-info">
                    <span className="sx-icon-bx-title">Execution Control</span>
                    <span className="sx-icon-bx-title-info">Clear standards and accountability</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="sx-icon-bx-2">
                  <div className="sx-media">
                    <i className="flaticon-data" />
                  </div>
                  <div className="sx-icon-bx-info">
                    <span className="sx-icon-bx-title">Decision Support</span>
                    <span className="sx-icon-bx-title-info">Fast updates and escalation signals</span>
                  </div>
                </div>
              </div>
            </div>
            <p>Consistent planning and communication reduces avoidable disruption and improves confidence for both client leadership and field teams.</p>
            <blockquote className="author-quote">
              <div className="sx-bq-media-wrap">
                <div className="sx-bq-media">
                  <i className="fa fa-quote-left" />
                  <ItodoImage src={neuronMedia.gallery[0]} alt="quote" />
                </div>
              </div>
              <h4 className="sx-bq-title">Neuron Operations Desk</h4>
              <span>Effective security outcomes come from clear preparation, disciplined execution and timely escalation.</span>
            </blockquote>
            <div className="row sx-single-small-media">
              <div className="col-md-6 col-sm-4">
                <div className="sx-box m-b30">
                  <div className="sx-media">
                    <ItodoImage src={neuronMedia.gallery[1]} alt="Operations planning" />
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-sm-4">
                <div className="sx-box m-b30">
                  <div className="sx-media">
                    <ItodoImage src={neuronMedia.gallery[3]} alt="Field execution" />
                  </div>
                </div>
              </div>
            </div>
            <h2 className="sx-post-detail-subtitle">Applying this insight in live assignments</h2>
            <p>Use this framework to review your own operating plans, stress-test decision points and tighten communication before high-priority activity windows.</p>
          </div>
          <div className="autor-post-tag-share">
            <div className="row">
              <div className="col-md-6">
                <div className="widget_tag_cloud single-post-tag">
                  <h6 className="tagcloud">Tags:</h6>
                  <div className="tagcloud">
                    {tags.map((tag) => (
                      <NavLink key={tag} to="/services">{tag}</NavLink>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="widget_social_inks sx-social-icons ">
                  <ul className="d-flex">
                    <li><a href="https://www.facebook.com/"><i className="fa fa-facebook" /></a></li>
                    <li><a href="https://www.instagram.com/"><i className="fa fa-instagram" /></a></li>
                    <li><a href="https://twitter.com/"><i className="fa fa-twitter" /></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="sx-blog-detail-author sx-bg-light">
            <div className="sx-media">
              <ItodoImage src={neuronMedia.gallery[4]} alt="author" />
            </div>
            <div className="sx-content">
              <h3 className="sx-title">Neuron Consultancy Editorial Desk</h3>
              <p>We publish practical security insights from field operations, advisory assignments and training deployments to support better planning and decision-making.</p>
            </div>
          </div>
          <div className="s-post-pagination-control previous-next previous next">
            <div className="paging-left paging-item">
              <div className="paging-content">
                <NavLink className="paging-link" to={`/insights/${prev.slug}`}>
                  <i className="fa fa-long-arrow-left" />
                </NavLink>
                <div className="paging-content-inner">
                  <NavLink className="paging-link2" to={`/insights/${prev.slug}`}>Previous Insight</NavLink>
                  <h4 className="paging-title">
                    <NavLink to={`/insights/${prev.slug}`}>{prev.title}</NavLink>
                  </h4>
                </div>
              </div>
            </div>
            <div className="paging-right paging-item">
              <div className="paging-content reverse">
                <NavLink className="paging-link" to={`/insights/${next.slug}`}>
                  <i className="fa fa-long-arrow-right" />
                </NavLink>
                <div className="paging-content-inner">
                  <NavLink className="paging-link2" to={`/insights/${next.slug}`}>Next Insight</NavLink>
                  <h4 className="paging-title">
                    <NavLink to={`/insights/${next.slug}`}>{next.title}</NavLink>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SectionInsightSingle;
